import React, { useMemo } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { EpsfAccessGate, epsfNavItemAllowed, useEpsfAccess } from "./epsfAccess";
import { EPSF_WORKSPACE_GROUPS } from "./epsfNav";
import { EpsfStudySiteProvider } from "./epsfLedgerUi";
import "./EpsfPages.scss";

function isNavItemActive(pathname, item) {
  const path = String(pathname || "").split("?")[0].replace(/\/+$/, "") || "/";
  const target = String(item.path || "").split("?")[0].replace(/\/+$/, "") || "/";
  if (item.end) return path === target;
  if (path === target) return true;
  return path.startsWith(`${target}/`);
}

function railLabel(item) {
  return item.shortTitle || item.title;
}

export default function EpsfWorkspace() {
  const access = useEpsfAccess();
  const { loading, canView, moduleAccess } = access;
  const allow = canView && moduleAccess;
  const location = useLocation();

  const groups = useMemo(
    () =>
      EPSF_WORKSPACE_GROUPS.map((group) => ({
        ...group,
        items: group.items.filter((item) => epsfNavItemAllowed(item, access)),
      })).filter((group) => group.items.length > 0),
    [access],
  );

  return (
    <EpsfAccessGate allow={allow} loading={loading}>
      <EpsfStudySiteProvider>
        <div className="epsf-workspace">
          <aside className="epsf-workspace__nav" aria-label="ePSF navigation">
            <nav className="epsf-workspace__groups">
              {groups.map((group) => (
                <div key={group.id} className="epsf-workspace__group">
                  <div
                    className="epsf-workspace__group-title"
                    title={group.title}
                  >
                    {group.shortTitle || group.title}
                  </div>
                  <ul className="epsf-workspace__list">
                    {group.items.map((item) => {
                      const active = isNavItemActive(location.pathname, item);
                      const label = railLabel(item);
                      return (
                        <li key={item.id}>
                          <NavLink
                            to={item.path}
                            end={Boolean(item.end)}
                            title={item.title}
                            className={`epsf-workspace__link${active ? " is-active" : ""}`}
                          >
                            <i className={item.icon} aria-hidden />
                            <span>{label}</span>
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </nav>
          </aside>

          <main className="epsf-workspace__main">
            <Outlet />
          </main>
        </div>
      </EpsfStudySiteProvider>
    </EpsfAccessGate>
  );
}
